export default "/power.687a5be1ac2beddb7f770a4197ea3fc4.svg";